<template>
  <div class="knowledge-page knowledge-client flex-col">
      <div class="knowledge-main-row">
      <div class="knowledge-left-panel flex-col align-stretch" style="flex-shrink:0;width:300px;flex-grow:1;">
        <div class="directory-panel-header">
          <span class="directory-panel-title">目录</span>
          <div class="directory-panel-toolbar">
            <Toolbar :items="directoryTools" v-model="toolBarValue" @on-event="handleDirectoryToolbarEvent" />
            <Button
              v-if="selectedDir && !isSelectedDirRoot"
              type="text"
              size="small"
              icon="md-settings"
              class="directory-config-btn"
              title="权限配置"
              @click="handleDirConfig(selectedDir)"
            />
          </div>
        </div>
        <KnowledgeDirectory
          :dirs="directories"
          :selected-dir="selectedDir"
          style="flex-grow:1"
          @on-select="handleDirSelect"
          @on-drop-in="handleDirDropIn"
          @on-drop-file="handleFileDropToDir"
          @on-config="handleDirConfig"
          @on-context-action="handleDirContextAction"
        ></KnowledgeDirectory>
      </div>
       
        <div class="flex-col align-stretch" style="flex-grow:1;width:calc(100% - 300px);">
          <div class="data-panel-header">
            <Input
              v-model="searchText"
              search
              placeholder="搜索内容"
              clearable
              class="data-search-input"
            />
            <Toolbar :items="dataTools" v-model="toolBarValue" @on-event="handleDataToolbarEvent" @input="handleToolbarInput" class="data-panel-toolbar"/>
          </div>
          <KnowledgeList
          style="flex-grow:1"
          :loading="loading"
          :items="filteredItems"
          :subdirs="selectedSubdirs"
          :all-items="allItems"
          :view-mode="viewMode"
          :dir-editable="selectedDirEditable"
          @on-drop-in-folder="handleItemDropInFolder"
          @on-select="handleItemSelect"
          @on-open="handleItemOpen"
          @on-edit="handleItemEdit"
          @on-file-drop="handleFileDrop"
          @on-dir-select="handleDirSelect"
          @on-context-menu="handleItemContextMenu"
          @on-markdown="handleItemMarkdown"
        ></KnowledgeList>
        </div>

      </div>
        <div class="knowledge-status-bar">
          <span class="status-path">
            <template v-if="!selectedDir">未选中</template>
            <template v-else>
              <span
                v-for="(dir, idx) in selectedDirPathArray"
                :key="dir.id"
                class="status-path-item"
              >
                <span v-if="idx > 0" class="status-path-sep"><BaseIcon icon="ios-arrow-forward" :size="12" /></span>
                <span class="status-path-link" @click="handleDirSelect(dir)">{{ dir.name }}</span>
              </span>
            </template>
          </span>
          <span class="status-meta">
            <span class="status-count">{{ selectedDir ? filteredItems.length : 0 }} 个文件</span>
            <span class="status-usage">128 MB / 1 GB</span>
          </span>
        </div>

        <Drawer v-model="showDetail" :width="800" :styles="{
          padding:0
        }">
          <KnowledgeDetail :current="current" :all-items="allItems" />
        </Drawer>

        <!-- 目录编辑对话框 -->
        <Modal v-model="showDirEditor" :title="dirEditorTitle" footer-hide :mask-closable="false">
          <div class="knowledge-modal-content">
            <Form :model="dirForm" :label-width="100">
              <FormItem label="目录类型">
                <RadioGroup v-model="dirForm.type" class="dir-type-selector">
                  <Radio label="dir" class="dir-type-option">
                    <BaseIcon icon="md-folder" :size="20" style="margin-right:5px;" />
                    <span>目录</span>
                  </Radio>
                  <Radio label="link-dir" class="dir-type-option">
                    <BaseIcon icon="lianjie" :size="20" style="margin-right:5px;" />
                    <span>引用目录</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="目录名称">
                <Input v-model="dirForm.name" placeholder="请输入目录名称" size="large" :maxlength="50" />
              </FormItem>
              <FormItem label="描述">
                <Input 
                  v-model="dirForm.description" 
                  type="textarea" 
                  :rows="3" 
                  placeholder="请输入目录描述（最多128字）" 
                  size="large"
                  :maxlength="128"
                  show-word-limit
                />
              </FormItem>
              <FormItem label="远程API" v-if="dirForm.type === 'link-dir'">
                <Input v-model="dirForm.remote_api" placeholder="请输入远程API地址" size="large" />
              </FormItem>
            </Form>
          </div>
          <div class="knowledge-modal-footer">
            <Button @click="handleDirCancel" size="large">取消</Button>
            <Button type="primary" @click="handleDirSubmit" size="large" style="margin-left:10px;">确定</Button>
          </div>
        </Modal>

        <!-- 目录权限配置对话框 -->
        <Modal v-model="showDirPermission" title="权限配置" footer-hide :mask-closable="false" width="400">
          <div class="knowledge-modal-content" v-if="permissionDir">
            <Form :model="permissionForm" :label-width="80">
              <FormItem label="目录">
                <span>{{ permissionDir.name }}</span>
              </FormItem>
              <FormItem label="可编辑">
                <Switch v-model="permissionForm.editable" />
                <span style="margin-left:8px;">{{ permissionForm.editable ? '可创建/移动/删除文件' : '只读' }}</span>
              </FormItem>
            </Form>
          </div>
          <div class="knowledge-modal-footer">
            <Button @click="showDirPermission = false" size="large">取消</Button>
            <Button type="primary" @click="handlePermissionSubmit" size="large" style="margin-left:10px;">确定</Button>
          </div>
        </Modal>

        <!-- 内容编辑对话框 -->
        <Modal v-model="showItemEditor" :title="itemEditorTitle" :width="1000" footer-hide :mask-closable="false">
          <div class="knowledge-modal-content">
            <Tabs v-model="editorTab">
              <TabPane label="基本信息" name="basic">
            <Form :model="itemForm" :label-width="100">
              <FormItem label="标题">
                <Input v-model="itemForm.name" placeholder="请输入标题" size="large" :maxlength="100" />
              </FormItem>
              <FormItem label="内容类型">
                <div class="type-selector">
                  <div
                    v-for="typeOption in typeOptions"
                    :key="typeOption.value"
                    class="type-option"
                    :class="{ 'active': itemForm.type === typeOption.value }"
                    @click="itemForm.type = typeOption.value; handleItemTypeChange()"
                  >
                    <BaseIcon :icon="typeOption.icon" :size="24" />
                    <span>{{ typeOption.label }}</span>
                  </div>
                </div>
              </FormItem>
              <FormItem label="所属目录">
                <Select v-model="itemForm.dir_id" clearable size="large" style="width:300px;">
                  <Option value="">无</Option>
                  <Option v-for="dir in allDirectories" :key="dir.id" :value="dir.id">{{ dir.name }}</Option>
                </Select>
              </FormItem>
              
              <!-- 文件类型 -->
              <FormItem label="文件上传" v-if="itemForm.type === 'file'">
                <Upload
                  :before-upload="handleFileUpload"
                  action=""
                >
                  <Button icon="ios-cloud-upload-outline" size="large">选择文件</Button>
                </Upload>
                <div v-if="itemForm.content" style="margin-top:10px;padding:10px;background:var(--bg3);border-radius:4px;">
                  <BaseIcon icon="wenjian" :size="18" style="margin-right:5px;" />
                  <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
                </div>
              </FormItem>

              <!-- 文本类型 -->
              <FormItem label="文本内容" v-if="itemForm.type === 'text'">
                <Input v-model="itemForm.content" type="textarea" :rows="12" placeholder="请输入文本内容" />
              </FormItem>

              <!-- Markdown类型 -->
              <FormItem label="Markdown内容" v-if="itemForm.type === 'md'">
                <div class="markdown-editor-wrapper">
                  <MarkdownEditor v-model="itemForm.content" />
                </div>
              </FormItem>

              <!-- HTML类型 -->
              <FormItem label="HTML内容" v-if="itemForm.type === 'html'">
                <div class="html-editor-wrapper">
                  <TextEditor v-model="itemForm.content" />
                </div>
              </FormItem>
            </Form>
              </TabPane>
              <TabPane label="Markdown解析" name="markdown">
                <div class="markdown-parse-panel">
                  <Alert show-icon>
                    将原始文件解析为 Markdown，用于摘要检索与原文链接；非 Markdown 格式文件可在此维护解析结果。
                  </Alert>
                  <Form :model="itemForm" :label-width="100" style="margin-top:16px;">
                    <FormItem label="解析状态">
                      <Tag :color="itemForm.has_markdown ? 'success' : 'default'">
                        {{ itemForm.has_markdown ? '已生成 Markdown' : '未解析' }}
                      </Tag>
                      <Button
                        v-if="showMarkdownParseBtn"
                        type="primary"
                        ghost
                        size="small"
                        style="margin-left:12px;"
                        :loading="markdownParsing"
                        @click="handleParseMarkdown"
                      >
                        触发解析
                      </Button>
                    </FormItem>
                    <FormItem label="摘要内容">
                      <div class="markdown-editor-wrapper">
                        <MarkdownEditor v-model="itemForm.markdown_content" />
                      </div>
                    </FormItem>
                    <FormItem label="原文链接" v-if="itemForm.content && itemForm.type === 'file'">
                      <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
                    </FormItem>
                  </Form>
                </div>
              </TabPane>
            </Tabs>
          </div>
          <div class="knowledge-modal-footer">
            <Button @click="handleItemCancel" size="large">取消</Button>
            <Button type="primary" @click="handleItemSubmit" size="large" style="margin-left:10px;">确定</Button>
          </div>
        </Modal>
  </div>
</template>

<script>
import KnowledgeDirectory from '@/components/knowledge/directory'
import KnowledgeList from '@/components/knowledge/list'
import KnowledgeDetail from '@/components/knowledge/detail'
import Toolbar from '@/components/app/toolbar'
import MarkdownEditor from '@/components/base/MarkdownEditor'
import TextEditor from '@/components/base/TextEditor'
import BaseIcon from '@/components/base/Icon'
import UTIL from '@/utils'

export default {
    routerOption: {},
    data(){
      return {
        directories:[],
        items:[],
        allItems:[],
        loading:false,
        showDetail:false,
        current:null,
        selectedDir:null,
        selectedItems:[],
        searchText:'',
        toolBarValue:{
          view_mode:'icon'
        },
        editorTab: 'basic',
        markdownParsing: false,
        showDirEditor:false,
        dirForm:{
          name:'',
          type:'dir',
          remote_api:'',
          description:''
        },
        showItemEditor:false,
        itemForm:{
          type:'text',
          content:'',
          dir_id:'',
          markdown_content:'',
          has_markdown: false,
        },
        showDirPermission:false,
        permissionDir:null,
        permissionForm:{ editable: true }
      }
    },
    components:{KnowledgeDirectory,KnowledgeList,Toolbar,KnowledgeDetail,MarkdownEditor,TextEditor,BaseIcon},
    computed:{
      viewMode(){
        if(this.toolBarValue){
          return this.toolBarValue.view_mode
        }
        return 'icon'
      },
      filteredItems(){
        let items = this.allItems
        if(this.selectedDir){
          const dirIds = this.getDirIdWithDescendants(this.selectedDir.id)
          items = items.filter(item => item.dir_id && dirIds.includes(item.dir_id))
        }
        if(this.searchText){
          const search = this.searchText.toLowerCase()
          items = items.filter(item => {
            const name = (item.name || '').toLowerCase()
            const content = (item.content || '').toLowerCase()
            return name.includes(search) || content.includes(search)
          })
        }
        return items
      },
      selectedDirPath(){
        if(!this.selectedDir) return ''
        return this.selectedDirPathArray.map(d => d.name).join(' / ')
      },
      selectedDirPathArray(){
        if(!this.selectedDir) return []
        const path = []
        let cur = this.selectedDir
        while(cur){
          path.unshift(cur)
          if(!cur.parent_id) break
          cur = this.allDirectories.find(d => d.id === cur.parent_id) || null
        }
        return path
      },
      selectedSubdirs(){
        if(!this.selectedDir) return []
        return (this.selectedDir.subs || []).slice()
      },
      selectedDirEditable(){
        if(!this.selectedDir) return true
        return this.selectedDir.editable !== false
      },
      isSelectedDirRoot(){
        if(!this.selectedDir) return false
        return this.selectedDir.parent_id === null || this.selectedDir.parent_id === undefined
      },
      allDirectories(){
        return UTIL.plat(this.directories, {LIST_KEY: 'subs'}) || []
      },
      availableDirectories(){
        return this.allDirectories.filter(dir => dir.id !== this.dirForm.id)
      },
      typeOptions(){
        return [
          { value: 'file', label: '文件', icon: 'wenjian' },
          { value: 'text', label: '文本', icon: 'md-document' },
          { value: 'md', label: 'Markdown', icon: 'codelibrary-fill' },
          { value: 'html', label: 'HTML', icon: 'css' },
        ]
      },
      directoryTools(){
        const hasSelected = !!this.selectedDir
        const isRoot = hasSelected && (this.selectedDir.parent_id === null || this.selectedDir.parent_id === undefined)
        const notEditable = hasSelected && this.selectedDir.editable === false
        const editBtns = [{
          type:"icon-button",
          icon:'md-create',
          name:'编辑',
          key:'edit',
          disabled:!hasSelected || isRoot
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled:!hasSelected || isRoot
        }]

        return [{
          type:"icon-button",
          icon:'md-add',
          name:'新增',
          key:'add',
          disabled: !hasSelected || notEditable
        },
        ...editBtns,
        ]
      },
      dataTools(){
        const hasSelected = this.selectedItems.length > 0
        const canEdit = this.selectedItems.length === 1
        const canMirror = this.selectedItems.length > 0 && this.selectedItems.every(item => item.type !== 'ref')
        const dirEditable = this.selectedDir && this.selectedDir.editable !== false
        const editBtns = [{
          type:"icon-button",
          icon:'md-create',
          name:'编辑',
          key:'edit',
          disabled: !hasSelected || !canEdit
        },{
          type:"icon-button",
          icon:'md-copy',
          name:'镜像',
          key:'mirror',
          disabled: !hasSelected || !canMirror
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled: !hasSelected
        }]

        return [{
          type:"icon-button",
          icon:'md-add',
          name:'新增',
          key:'add',
          disabled: !this.selectedDir || !dirEditable
        },
        ...editBtns,
        {
          type:'divider',
        },
        {
          type:'tabs',
          key:'view_mode',
          subs:[{
          type:"icon-button",
          icon:'md-speedometer',
          name:'图标',
          togglable:true,
          key:'icon',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'列表',
          togglable:true,
          key:'list',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'大纲',
          togglable:true,
          key:'brief',
        }]
        }]
      },
      dirEditorTitle(){
        return this.dirForm.id ? '编辑目录' : '新建目录'
      },
      itemEditorTitle(){
        return this.itemForm.id ? '编辑内容' : '新建内容'
      },
      showMarkdownParseBtn() {
        return this.itemForm.type === 'file';
      },
    },
    mounted(){
      this.loading = true
      this.$api.afterLogin(()=>{
        this.fetchDirectories()
        this.fetchItems()
      })
    },
    methods:{
      fetchDirectories(){
        this.loading = true
        this.$api.get('/knowledge/directories').then(res=>{
          this.directories = res.data.data || []
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取目录列表失败: ' + err)
          this.loading = false
        })
      },
      fetchItems(){
        this.loading = true
        this.$api.get('/knowledge/data').then(res=>{
          this.allItems = res.data.data || []
          this.items = this.allItems
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取内容列表失败: ' + err)
          this.loading = false
        })
      },
      getDirIdWithDescendants(dirId){
        const ids = [dirId]
        const children = (this.allDirectories || []).filter(d => d.parent_id === dirId)
        children.forEach(c => {
          ids.push(...this.getDirIdWithDescendants(c.id))
        })
        return ids
      },
      handleDirSelect(dir){
        this.selectedDir = dir
        this.selectedItems = []
      },
      handleDirConfig(dir){
        this.permissionDir = dir
        this.permissionForm = { editable: dir.editable !== false }
        this.showDirPermission = true
      },
      handlePermissionSubmit(){
        if(!this.permissionDir) return
        this.$api.patch(`/knowledge/directories/${this.permissionDir.id}`, {
          editable: this.permissionForm.editable
        }).then(() => {
          this.$Message.success('保存成功')
          this.showDirPermission = false
          this.fetchDirectories()
        }).catch(err => {
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleDirContextAction({ action, dir }){
        if(!dir) return
        if(action === 'add'){
          this.selectedDir = dir
          this.dirForm = { name: '', type: 'dir', parent_id: dir.id, remote_api: '', description: '' }
          this.showDirEditor = true
        } else if(action === 'edit'){
          this.selectedDir = dir
          this.dirForm = { id: dir.id, name: dir.name, type: dir.type, parent_id: dir.parent_id, remote_api: dir.remote_api || '', description: dir.description || '' }
          this.showDirEditor = true
        } else if(action === 'remove'){
          this.$Modal.confirm({
            title: '确认删除',
            content: `确定要删除目录"${dir.name}"吗？`,
            onOk: () => {
              this.$api.delete(`/knowledge/directories/${dir.id}`).then(() => {
                this.$Message.success('删除成功')
                if(this.selectedDir && this.selectedDir.id === dir.id) this.selectedDir = null
                this.fetchDirectories()
              }).catch(err => this.$Message.error('删除失败: ' + err))
            }
          })
        }
      },
      handleItemContextMenu(payload){
        const { action, item } = payload
        if(action === 'edit' && item){
          this.handleItemEdit(item)
        } else if(action === 'remove' && item){
          this.selectedItems = [item]
          this.handleDataToolbarEvent({ key: 'remove' })
        } else if(action === 'open' && item){
          this.handleItemOpen(item)
        }
      },
      handleItemSelect(items){
        this.selectedItems = items
      },
      handleDirDropIn(data){
        const {draggedId, targetDirId} = data
        const targetDir = this.allDirectories.find(d => d.id === targetDirId)
        if(targetDir && targetDir.editable === false){
          this.$Message.warning('该目录为只读，无法放入')
          return
        }
        const isDirectory = this.allDirectories.some(dir => dir.id === draggedId)
        if(isDirectory){
          this.$api.put(`/knowledge/directories/${draggedId}`, {
            parent_id: targetDirId
          }).then(()=>{
            this.$Message.success('移动成功')
            this.fetchDirectories()
          }).catch(err=>{
            this.$Message.error('移动失败: ' + err)
          })
        }
        // 如果是文件，会在handleFileDropToDir中处理
      },
      handleFileDropToDir(data){
        const {draggedId, targetDirId} = data
        const targetDir = this.allDirectories.find(d => d.id === targetDirId)
        if(targetDir && targetDir.editable === false){
          this.$Message.warning('该目录为只读，无法移动文件')
          return
        }
        const draggedItem = this.allItems.find(item => item.id === draggedId)
        if(draggedItem){
          this.$api.put(`/knowledge/data/${draggedId}`, {
            dir_id: targetDirId
          }).then(()=>{
            this.$Message.success('移动成功')
            // 如果当前选中的目录就是目标目录，则刷新列表；否则从列表中移除该文件
            if(this.selectedDir && this.selectedDir.id === targetDirId){
              this.fetchItems()
            } else {
              // 从当前列表中移除该文件（本地更新）
              this.items = this.items.filter(item => item.id !== draggedId)
              this.allItems = this.allItems.map(item => {
                if(item.id === draggedId){
                  return {...item, dir_id: targetDirId}
                }
                return item
              })
            }
          }).catch(err=>{
            this.$Message.error('移动失败: ' + err)
          })
        }
      },
      handleItemDropInFolder(data){
        const {draggedId, targetItemId} = data
        const targetItem = this.allItems.find(item => item.id === targetItemId)
        if(!targetItem || !targetItem.dir_id){
          this.$Message.warning('无法移动到该位置')
          return
        }
        this.$api.put(`/knowledge/data/${draggedId}`, {
          dir_id: targetItem.dir_id
        }).then(()=>{
          this.$Message.success('移动成功')
          this.fetchItems()
        }).catch(err=>{
          this.$Message.error('移动失败: ' + err)
        })
      },
      handleFileDrop(files){
        if(!files || files.length === 0) return
        if(!this.selectedDir){
          this.$Message.warning('请先选择目录')
          return
        }
        if(this.selectedDir.editable === false){
          this.$Message.warning('当前目录为只读，无法上传')
          return
        }
        const dirId = this.selectedDir.id
        const coskey = this.$store.getters['session/session'] && this.$store.getters['session/session'].coskey
        if(!coskey){
          this.$Message.warning('未配置上传，请使用「新增」选择文件上传')
          return
        }
        this.$cos.upload(files, {
          onSuccess: (uploaded) => {
            if(uploaded && uploaded.length > 0){
              const promises = uploaded.map(f => {
                const name = (f.name || '').replace(/\.[^/.]+$/, '') || '未命名'
                return this.$api.post('/knowledge/data', {
                  type: 'file',
                  content: f.url,
                  dir_id: dirId,
                  name: name || undefined
                })
              })
              Promise.all(promises).then(() => {
                this.$Message.success(`成功上传 ${uploaded.length} 个文件`)
                this.fetchItems()
              }).catch(err => this.$Message.error('创建记录失败: ' + err))
            }
          },
          onFail: (err) => this.$Message.error('上传失败: ' + err)
        }, { coskey })
      },
      handleDirectoryToolbarEvent(e){
        const {key} = e
        if(key === 'add'){
          this.dirForm = {
            name:'',
            type:'dir',
            parent_id:this.selectedDir ? this.selectedDir.id : null,
            remote_api:'',
            description:''
          }
          this.showDirEditor = true
        }else if(key === 'edit'){
          if(!this.selectedDir) return
          // 系统目录不可编辑
          if(this.selectedDir.type === 'system'){
            this.$Message.warning('系统目录不可编辑')
            return
          }
          this.dirForm = {
            id:this.selectedDir.id,
            name:this.selectedDir.name,
            type:this.selectedDir.type,
            parent_id:this.selectedDir.parent_id,
            remote_api:this.selectedDir.remote_api || '',
            description:this.selectedDir.description || ''
          }
          this.showDirEditor = true
        }else if(key === 'remove'){
          if(!this.selectedDir) return
          // 系统目录不可删除
          if(this.selectedDir.type === 'system'){
            this.$Message.warning('系统目录不可删除')
            return
          }
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除目录"${this.selectedDir.name}"吗？`,
            onOk:()=>{
              this.$api.delete(`/knowledge/directories/${this.selectedDir.id}`).then(()=>{
                this.$Message.success('删除成功')
                this.selectedDir = null
                this.fetchDirectories()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }
      },
      handleDataToolbarEvent(e){
        const {key,type,value} = e
        if(key === 'add'){
          this.editorTab = 'basic';
          this.itemForm = {
            type:'text',
            content:'',
            dir_id: this.selectedDir ? this.selectedDir.id : '',
            name:'',
            markdown_content:'',
            has_markdown: false,
          };
          this.showItemEditor = true
        }else if(key === 'edit'){
          if(this.selectedItems.length !== 1) return
          const item = this.selectedItems[0]
          this.fillItemForm(item)
          this.showItemEditor = true
        }else if(key === 'remove'){
          if(this.selectedItems.length === 0) return
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除选中的${this.selectedItems.length}个项目吗？`,
            onOk:()=>{
              const promises = this.selectedItems.map(item => 
                this.$api.delete(`/knowledge/data/${item.id}`)
              )
              Promise.all(promises).then(()=>{
                this.$Message.success('删除成功')
                this.selectedItems = []
                this.fetchItems()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }else if(type == 'tab-change'){
          this.toolBarValue.toolBarValue.view_mode = value
        }else if(key === 'mirror'){
          if(this.selectedItems.length === 0) return
          // 检查是否都是引用类型，引用类型不能镜像
          if(this.selectedItems.some(item => item.ref)){
            this.$Message.warning('引用类型不能创建镜像')
            return
          }
          // 直接在当前选中的目录创建镜像，如果没有选中目录则使用原文件的目录
          const targetDirId = this.selectedDir ? this.selectedDir.id : (this.selectedItems[0] ? this.selectedItems[0].dir_id : null)
          
          if(!targetDirId){
            this.$Message.warning('请先选择目录')
            return
          }
          
          // 为每个选中的项目创建引用数据，保持原类型和名称，设置ref为true
          const promises = this.selectedItems.map(item => {
            // 获取源文件（如果是引用文件，需要找到真正的源文件）
            const sourceItem = item.ref && item.content ? this.allItems.find(i => i.id === item.content) : item
            return this.$api.post('/knowledge/data', {
              type: sourceItem.type, // 保持原类型
              content: sourceItem.id, // 引用原始内容的ID
              dir_id: targetDirId,
              ref: true // 标记为引用
            })
          })
          
          Promise.all(promises).then(()=>{
            this.$Message.success(`成功创建 ${this.selectedItems.length} 个镜像`)
            this.fetchItems()
          }).catch(err=>{
            this.$Message.error('创建镜像失败: ' + err)
          })
        }
      },
      handleDirSubmit(){
        if(!this.dirForm.name){
          this.$Message.warning('请输入目录名称')
          return
        }
        const url = this.dirForm.id 
          ? `/knowledge/directories/${this.dirForm.id}`
          : '/knowledge/directories'
        const method = this.dirForm.id ? 'put' : 'post'
        
        this.$api[method](url, this.dirForm).then(()=>{
          this.$Message.success('保存成功')
          this.showDirEditor = false
          this.fetchDirectories()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleDirCancel(){
        this.showDirEditor = false
        this.dirForm = {
          name:'',
          type:'dir',
          parent_id:null,
          remote_api:'',
          description:''
        }
      },
      handleItemSubmit(){
        if(!this.itemForm.type){
          this.$Message.warning('请选择类型')
          return
        }
        if(this.itemForm.type === 'file' && !this.itemForm.content){
          this.$Message.warning('请上传文件')
          return
        }
        if(this.itemForm.type !== 'file' && !this.itemForm.content){
          this.$Message.warning('请输入内容')
          return
        }
        const url = this.itemForm.id 
          ? `/knowledge/data/${this.itemForm.id}`
          : '/knowledge/data'
        const method = this.itemForm.id ? 'put' : 'post'
        const payload = {
          ...this.itemForm,
          dir_id: this.itemForm.dir_id || null,
          markdown_content: this.itemForm.markdown_content,
          has_markdown: this.itemForm.has_markdown,
        };
        this.$api[method](url, payload).then(()=>{
          this.$Message.success('保存成功')
          this.showItemEditor = false
          this.fetchItems()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleItemCancel(){
        this.showItemEditor = false
        this.itemForm = {
          type:'text',
          content:'',
          dir_id:'',
          name:'',
          markdown_content:'',
          has_markdown: false,
        };
        this.editorTab = 'basic';
      },
      handleItemTypeChange(){
        this.itemForm.content = ''
      },
      handleFileUpload(file){
        // 自动获取文件名称
        const fileName = file.name || ''
        if(!this.itemForm.name && fileName){
          // 去掉扩展名作为默认名称
          const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
          this.itemForm.name = nameWithoutExt
        }
        
        this.$cos.upload([file], {
          onSuccess: (files) => {
            if(files && files.length > 0){
              this.itemForm.content = files[0].url
              // 如果还没有设置名称，使用文件名
              if(!this.itemForm.name && fileName){
                const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
                this.itemForm.name = nameWithoutExt
              }
              this.$Message.success('文件上传成功')
            }
          },
          onFail: (err) => {
            this.$Message.error('文件上传失败: ' + err)
          }
        }, {
          coskey: this.$store.getters['session/session'].coskey
        })
        return false
      },
      handleItemOpen(item){
        this.current = item
        this.showDetail = true
      },
      fillItemForm(item) {
        this.editorTab = 'basic';
        this.itemForm = {
          id: item.id,
          type: item.type,
          content: item.content || '',
          dir_id: item.dir_id != null ? item.dir_id : '',
          name: item.name || '',
          markdown_content: item.markdown_content || '',
          has_markdown: !!(item.has_markdown || item.markdown_content),
          audit_status: item.audit_status,
          rag_status: item.rag_status,
        };
      },
      handleItemEdit(item){
        this.fillItemForm(item);
        this.showItemEditor = true;
      },
      handleItemMarkdown(item) {
        this.fillItemForm(item);
        this.editorTab = 'markdown';
        this.showItemEditor = true;
      },
      handleParseMarkdown() {
        if (!this.itemForm.content) {
          this.$Message.warning('请先上传文件');
          return;
        }
        this.markdownParsing = true;
        setTimeout(() => {
          this.itemForm.markdown_content = this.itemForm.markdown_content || `# ${this.itemForm.name || '文档摘要'}\n\n> 由系统自动解析生成，便于检索与预览。\n\n[查看原文](${this.itemForm.content})`;
          this.itemForm.has_markdown = true;
          this.markdownParsing = false;
          this.$Message.success('Markdown 解析完成');
        }, 800);
      },
      handleSearch(){
        // 搜索逻辑已在computed中处理
      },
      handleToolbarInput(value){
        this.toolBarValue = value
        // 视图切换时更新 viewMode
        if(value && value.toolBarValue && value.toolBarValue.view_mode){
          // viewMode 会通过 computed 自动更新
        }
      },
      getItemIcon(item){
        // 如果是文件类型，根据文件扩展名返回不同图标
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || ''
          const ext = fileName.split('.').pop().toLowerCase()
          return this.getFileIconByExt(ext)
        }
        
        // 其他类型使用固定图标
        const iconMap = {
          text: 'md-document',
          md: 'codelibrary-fill',
          html: 'css',
          ref: 'lianjie',
        }
        return iconMap[item.type] || 'wenjian'
      },
      getFileIconByExt(ext){
        const extIconMap = {
          'txt': 'md-document-text',
          'doc': 'md-document',
          'docx': 'md-document',
          'pdf': 'md-document',
          'xls': 'md-document',
          'xlsx': 'md-document',
          'ppt': 'md-document',
          'pptx': 'md-document',
          'js': 'codelibrary-fill',
          'ts': 'codelibrary-fill',
          'jsx': 'codelibrary-fill',
          'tsx': 'codelibrary-fill',
          'vue': 'codelibrary-fill',
          'py': 'codelibrary-fill',
          'java': 'codelibrary-fill',
          'cpp': 'codelibrary-fill',
          'c': 'codelibrary-fill',
          'go': 'codelibrary-fill',
          'php': 'codelibrary-fill',
          'rb': 'codelibrary-fill',
          'md': 'codelibrary-fill',
          'html': 'css',
          'htm': 'css',
          'xml': 'css',
          'json': 'codelibrary-fill',
          'yaml': 'codelibrary-fill',
          'yml': 'codelibrary-fill',
          'jpg': 'images',
          'jpeg': 'images',
          'png': 'images',
          'gif': 'images',
          'svg': 'images',
          'webp': 'images',
          'bmp': 'images',
          'zip': 'wenjian',
          'rar': 'wenjian',
          '7z': 'wenjian',
          'tar': 'wenjian',
          'gz': 'wenjian',
          'mp4': 'shipin',
          'avi': 'shipin',
          'mov': 'shipin',
          'mp3': 'shipin',
          'wav': 'shipin',
        }
        return extIconMap[ext] || 'wenjian'
      },
      getItemName(item){
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || '未命名文件'
          return fileName
        }
        if(item.type === 'text' || item.type === 'md' || item.type === 'html'){
          const content = item.content || ''
          const firstLine = content.split('\n')[0] || '未命名文档'
          return firstLine.substring(0, 30) + (firstLine.length > 30 ? '...' : '')
        }
        return '未命名'
      },
    }
}
</script>

<style lang="less" scoped>
.knowledge-page {
  height: 100%;
  min-height: 0;
  background: var(--bg2);
}

.markdown-parse-panel {
  padding: 4px 0;
}

.knowledge-modal-content {
  padding: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.knowledge-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  background: var(--bg3);
}

.markdown-editor-wrapper {
  position: relative;
  z-index: 1;
  
  /deep/ .v-note-wrapper {
    min-height: 500px;
    z-index: 1;
  }
  
  /deep/ .v-note-toolbar {
    z-index: 1000 !important;
    position: relative;
  }
  
  /deep/ .v-note-edit {
    min-height: 400px;
  }
}

.html-editor-wrapper {
  position: relative;
  min-height: 500px;
  
  /deep/ .tox-tinymce {
    min-height: 500px;
  }
  
  /deep/ .tox-edit-area {
    min-height: 450px;
  }
}

.type-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  border: 2px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 100px;
  background: var(--bg3);
  
  &:hover {
    border-color: var(--primary);
    background: var(--primary-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &.active {
    border-color: var(--primary);
    background: var(--primary);
    color: #fff;
    box-shadow: 0 4px 12px rgba(51, 153, 255, 0.3);
  }
  
  span {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
  }
}

.knowledge-left-panel {
  background: #fff;
  border-right: 1px solid var(--border);
}

.directory-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-bottom: 1px solid var(--border);
  min-height: 40px;
  .directory-panel-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--text);
  }
  .directory-panel-toolbar {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }
  .directory-config-btn {
    padding: 4px 8px;
  }
}

.knowledge-client {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.knowledge-main-row {
  flex: 1;
  display: flex;
  width:100%;
  min-height: 0;
  min-width: 0;
}

.knowledge-status-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  font-size: 12px;
  color: var(--subtext2);
  background: var(--bg3);
  border-top: 1px solid var(--border);
  width: 100%;
  .status-path {
    flex: 1;
    overflow: hidden;
    margin-right: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
  }
  .status-path-item {
    display: inline-flex;
    align-items: center;
  }
  .status-path-sep {
    display: inline-flex;
    align-items: center;
    margin: 0 4px;
    color: var(--subtext3);
  }
  .status-path-link {
    cursor: pointer;
    color: var(--subtext2);
  }
  .status-path-link:hover {
    color: var(--primary);
  }
  .status-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }
  .status-count,
  .status-usage {
    color: var(--subtext3);
  }
}

.data-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-bottom: 1px solid var(--border);
  gap: 12px;
  .data-search-input {
    width: 200px;
    flex-shrink: 0;
  }
  .data-panel-toolbar {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: flex-end;
    /deep/ .u-toolbar {
      margin-left: auto;
    }
  }
}

.dir-type-selector {
  display: flex;
  gap: 10px;
  
  .dir-type-option {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border: 2px solid var(--border);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    background: var(--bg3);
    
    &:hover {
      border-color: var(--primary);
      background: var(--primary-light);
    }
    
    /deep/ .ivu-radio-wrapper {
      display: flex;
      align-items: center;
      margin: 0;
      
      .ivu-radio {
        margin-right: 8px;
      }
    }
    
    /deep/ .ivu-radio-wrapper-checked {
      border-color: var(--primary);
      background: var(--primary);
      color: #fff;
    }
  }
}

</style>